export function ArticleFooter() {
  return (
    <div className="article-footer">
      <div className="pt-8">
        Questions? Comments? Feedback? Concerns?
      </div>
      <div className="pt-8">
        Click the &ldquo;Contact Support&rdquo; link below or email us at: <a href="mailto:support@weatherroute.io" className="underline">support@weatherroute.io</a>
      </div>
      <div className="pt-8">
        <a href="https://www.weatherroute.io/" className="underline"><strong>Download Highway Weather</strong></a>
      </div>
      <div className="pt-8">
        <a href="https://www.facebook.com/weatherroute" className="underline">Follow Us on Facebook</a> for More Weather and App-Related Updates!
      </div>
    </div>
  );
} 